import { DocumentTitle } from 'src/routes/components';

import { SimpleLayout } from 'src/layouts/simple';

import { Logo } from 'src/components/logo';

const LayoutAuth0 = ({ children }: { children: React.ReactNode }) => (
    <SimpleLayout
      slotProps={{
        footer: { sx: { display: 'none' } },
        header: {
          slots: {
            rightArea: <></>,
            leftArea: <Logo isSingle={false} />,
          },
        },
        content: {},
      }}
      sx={{
        backgroundImage: (theme) => (theme.palette as any).backgroundImage,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <DocumentTitle />
      {children}
    </SimpleLayout>
  );

export default LayoutAuth0;
